const COUNTRY_BY_LANGUAGE = {
  da: "DK",
  de: "DE",
  en: "US"
};
const submitLocalization = (language, country) => {
  const form = document.createElement("form");
  form.action = "/localization";
  form.method = "POST";
  form.hidden = true;
  const fields = {
    _method: "PUT",
    language_code: language,
    country_code: country
  };
  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.name = name;
    input.value = value;
    form.append(input);
  });
  document.body.append(form);
  form.submit();
};
const initLanguageCountrySwitch = () => {
  document.querySelectorAll("form.localization-form").forEach((form) => {
    form.addEventListener(
      "click",
      (event) => {
        const link = event.target.closest(".disclosure__link[hreflang]");
        const language = link?.dataset.value?.toLowerCase();
        const country = language ? COUNTRY_BY_LANGUAGE[language] : void 0;
        if (!language || !country) {
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        submitLocalization(language, country);
      },
      { capture: true }
    );
  });
};
const VISIBLE_COUNT = 7;
const HIDDEN_CLASS = "tw:hidden!";
class ProductSiblings extends HTMLElement {
  label = null;
  siblings = [];
  more = null;
  less = null;
  connectedCallback() {
    this.label = this.querySelector("[data-selected-color]");
    this.siblings = Array.from(this.querySelectorAll("[data-sibling]"));
    this.more = this.querySelector("[data-siblings-more]");
    this.less = this.querySelector("[data-siblings-less]");
    const selectedColor = this.label?.textContent ?? "";
    this.siblings.forEach((sibling) => {
      const img = sibling.querySelector("img");
      sibling.addEventListener("mouseenter", () => {
        if (this.label && sibling.dataset.title) this.label.textContent = sibling.dataset.title;
        if (img) img.style.transform = "scale(1.1)";
      });
      sibling.addEventListener("mouseleave", () => {
        if (this.label) this.label.textContent = selectedColor;
        if (img && !sibling.classList.contains("selected-sibling")) img.style.transform = "scale(1)";
      });
    });
    this.more?.addEventListener("click", this.showAll);
    this.less?.addEventListener("click", this.collapse);
  }
  showAll = (event) => {
    event.preventDefault();
    this.siblings.forEach((sibling, index) => {
      sibling.classList.remove(HIDDEN_CLASS);
      sibling.style.display = "flex";
      sibling.style.opacity = "0";
      setTimeout(() => {
        sibling.style.opacity = "1";
      }, 15 * index);
    });
    this.more?.classList.add(HIDDEN_CLASS);
    this.less?.classList.remove(HIDDEN_CLASS);
  };
  collapse = (event) => {
    event.preventDefault();
    const last = this.siblings.length - 1;
    this.siblings.forEach((sibling, index) => {
      if (index < VISIBLE_COUNT) return;
      setTimeout(
        () => {
          sibling.style.opacity = "0";
          setTimeout(() => {
            sibling.style.display = "none";
          }, 500);
        },
        15 * (last - index)
      );
    });
    this.less?.classList.add(HIDDEN_CLASS);
    this.more?.classList.remove(HIDDEN_CLASS);
  };
}
class Wishlist extends HTMLElement {
  url = this.dataset.url;
  constructor() {
    super();
    this.addEventListeners = this.addEventListeners.bind(this);
    this.handleShareWishlist = this.handleShareWishlist.bind(this);
    this.setCounter = this.setCounter.bind(this);
    this.renderWishlistItems = this.renderWishlistItems.bind(this);
    this.generateWishlistItems = this.generateWishlistItems.bind(this);
    this.createSkeletonLoader = this.createSkeletonLoader.bind(this);
    this.checkForSharedWishlist = this.checkForSharedWishlist.bind(this);
    this.showOrHideSubtitle = this.showOrHideSubtitle.bind(this);
  }
  async connectedCallback() {
    this.addEventListeners();
    await this.renderWishlistItems();
    const currentWishlist = localStorage.getItem("wishlist");
    const parsedWishlist = currentWishlist ? JSON.parse(currentWishlist) : [];
    this.setCounter(parsedWishlist.length);
    this.showOrHideSubtitle();
  }
  addEventListeners() {
    const shareButton = document.getElementById("share-wishlist");
    if (shareButton) {
      shareButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.handleShareWishlist();
      });
    }
    this.checkForSharedWishlist();
    document.addEventListener("wishlistUpdated", async (event) => {
      this.setCounter(event.detail.wishlistCount);
      await this.renderWishlistItems();
      this.showOrHideSubtitle();
    });
    document.addEventListener("DOMContentLoaded", async () => {
      this.showOrHideSubtitle();
    });
  }
  showOrHideSubtitle() {
    let wishlistCount = 0;
    const subtitle = document.querySelector(".wishlist-subtitle");
    const currentWishlist = localStorage.getItem("wishlist");
    const parsedWishlist = currentWishlist ? JSON.parse(currentWishlist) : [];
    wishlistCount = parsedWishlist.length || 0;
    if (subtitle) {
      if (wishlistCount === 0) {
        subtitle.classList.remove("tw:hidden");
      } else {
        subtitle.classList.add("tw:hidden");
      }
    }
  }
  async renderWishlistItems() {
    const currentWishlist = localStorage.getItem("wishlist");
    const parsedWishlist = currentWishlist ? JSON.parse(currentWishlist) : [];
    this.innerHTML = "";
    if (parsedWishlist.length === 0) {
      return;
    }
    this.innerHTML = `
      ${parsedWishlist.map(() => this.createSkeletonLoader()).join("")}
  `;
    const wishlistItemsHtml = await this.generateWishlistItems(parsedWishlist);
    this.innerHTML = wishlistItemsHtml;
  }
  async generateWishlistItems(parsedWishlist) {
    try {
      const batchSize = 20;
      const batches = [];
      const idsArray = parsedWishlist.map((id) => `id:${id}`);
      for (let i = 0; i < idsArray.length; i += batchSize) {
        batches.push(idsArray.slice(i, i + batchSize).join(" OR "));
      }
      const responses = await Promise.all(
        batches.map(
          (batchQuery) => fetch(`${this.url}&q=${batchQuery}`).then((res) => {
            if (!res.ok) throw new Error("Network response was not ok");
            return res.text();
          })
        )
      );
      const template = document.createElement("template");
      const wishlitItemsHtml = responses.map((response) => {
        template.innerHTML = response;
        const wishlistItemsWrapper = template.content.querySelector("wishlist-component");
        return wishlistItemsWrapper ? Array.from(wishlistItemsWrapper.children).map((child) => child.outerHTML).join("") : "";
      }).join("");
      return wishlitItemsHtml;
    } catch (error) {
      console.error(error);
    }
    return "";
  }
  createSkeletonLoader() {
    return `
      <div class="tw:animate-pulse tw:rounded-lg tw:border tw:bg-gray-200 tw:shadow-md tw:overflow-hidden">
        <div class="tw:w-full tw:h-[165px] tw:md:h-[250px] tw:bg-gray-300 tw:block!"></div>
        <div class="tw:p-6 tw:flex tw:flex-col tw:gap-4">
          <div class="tw:w-3/4 tw:h-6 tw:bg-gray-300 tw:rounded tw:block!"></div>
          <div class="tw:w-1/2 tw:h-4 tw:bg-gray-300 tw:rounded tw:block!"></div>
          <div class="tw:w-1/3 tw:h-4 tw:bg-gray-300 tw:rounded tw:block!"></div>
          <div class="tw:w-1/4 tw:h-4 tw:bg-gray-300 tw:rounded tw:block!"></div>
          <div class="tw:w-1/2 tw:h-4 tw:bg-gray-300 tw:rounded tw:block!"></div>
          <div class="tw:w-1/3 tw:h-4 tw:bg-gray-300 tw:rounded tw:block!"></div>
          <div class="tw:w-1/4 tw:h-4 tw:bg-gray-300 tw:rounded tw:block!"></div>
          <div class="tw:w-1/2 tw:h-4 tw:bg-gray-300 tw:rounded tw:block!"></div>
          <div class="tw:w-full tw:h-10 tw:bg-gray-300 tw:rounded tw:block!"></div>
          <div class="tw:w-1/2 tw:h-4 tw:mx-auto tw:bg-gray-300 tw:rounded tw:block!"></div>
        </div>
      </div>
    `;
  }
  checkForSharedWishlist() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.get("wishlist");
  }
  async handleShareWishlist() {
    const currentWishlist = localStorage.getItem("wishlist");
    const parsedWishlist = currentWishlist ? JSON.parse(currentWishlist) : [];
    if (parsedWishlist.length === 0) {
      return;
    }
    const queryString = parsedWishlist.join(",");
    const shareUrl = `${window.location.href}?wishlist=${queryString}`;
    await navigator.clipboard.writeText(shareUrl);
  }
  setCounter(count) {
    const counter = document.getElementById("counter-indicator");
    if (!counter) return;
    counter.textContent = count.toString();
    counter.classList.toggle("tw:hidden", count === 0);
    counter.classList.toggle("tw:flex", count > 0);
  }
}
class WishlistButton extends HTMLElement {
  id = this.dataset.id;
  constructor() {
    super();
    this.addEventListeners = this.addEventListeners.bind(this);
    this.toggleProductInWishlist = this.toggleProductInWishlist.bind(this);
    this.checkIfProductIsInWishlist = this.checkIfProductIsInWishlist.bind(this);
  }
  connectedCallback() {
    this.checkIfProductIsInWishlist();
    this.addEventListeners();
  }
  addEventListeners() {
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.toggleProductInWishlist();
      this.animateWishlistButton(event);
    });
  }
  toggleProductInWishlist() {
    const wishlist = localStorage.getItem("wishlist");
    const parsedWishlist = wishlist ? JSON.parse(wishlist) : [];
    const productIndex = parsedWishlist.findIndex((item) => item === this.id);
    if (productIndex !== -1) {
      parsedWishlist.splice(productIndex, 1);
    } else {
      parsedWishlist.push(this.id);
    }
    localStorage.setItem("wishlist", JSON.stringify(parsedWishlist));
    this.classList.toggle("added-to-wishlist");
    const wishlistUpdatedEvent = new CustomEvent("wishlistUpdated", {
      detail: { wishlistCount: parsedWishlist.length, rerender: true }
    });
    document.dispatchEvent(wishlistUpdatedEvent);
  }
  checkIfProductIsInWishlist() {
    const wishlist = localStorage.getItem("wishlist");
    if (wishlist) {
      const parsedWishlist = JSON.parse(wishlist);
      if (parsedWishlist.includes(this.id)) {
        this.classList.add("added-to-wishlist");
      }
    }
  }
  animateWishlistButton(event) {
    const particleWrapper = this.querySelector(".particles-wrapper");
    if (!particleWrapper) return;
    let clientX;
    let clientY;
    if (event instanceof MouseEvent) {
      clientX = event.clientX;
      clientY = event.clientY;
    } else if (event instanceof TouchEvent) {
      clientX = event.touches[0].clientX;
      clientY = event.touches[0].clientY;
    } else {
      return;
    }
    const rect = particleWrapper.getBoundingClientRect();
    const offsetX = clientX - rect.left;
    const offsetY = clientY - rect.top;
    for (let i = 0; i < 15; i += 1) {
      const particle = document.createElement("div");
      particle.classList.add("particles");
      const angle = Math.random() * 2 * Math.PI;
      const distance = Math.random() * 20 + 10;
      const x = Math.cos(angle) * distance;
      const y = Math.sin(angle) * distance;
      particle.style.left = `${offsetX}px`;
      particle.style.top = `${offsetY}px`;
      particle.style.setProperty("--x", `${x}px`);
      particle.style.setProperty("--y", `${y}px`);
      particleWrapper.appendChild(particle);
      setTimeout(() => particle.remove(), 2e3);
    }
  }
}
customElements.define("wishlist-button", WishlistButton);
customElements.define("wishlist-component", Wishlist);
customElements.define("product-siblings", ProductSiblings);
initLanguageCountrySwitch();
